import { Injectable } from "@angular/core";
import { UsersService } from "./users.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class ConverterService {

  constructor(private usersService: UsersService, private translate: TranslateService) {
  }

  private IsMetric(): boolean {
    return this.usersService.getCurrentUser().Flags.indexOf('MILES') < 0;
  }
  public Units(str: string): string {
    switch (str) {
      case "km/h":
        return this.IsMetric() ? this.translate.instant("km/h") : this.translate.instant("mi/h");
      case "m":
        return this.IsMetric() ? this.translate.instant("m") : this.translate.instant("ft");
      case "km":
        return this.IsMetric() ? this.translate.instant("km") : this.translate.instant("ft");
    }
    return "";
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  public GetSpeedValue(speed: number): number { return this.SpeedValue(speed, false); }
  public GetSpeed(speed: number): string { return this.GetSpeedValue(speed) + " " + this.Units("km/h"); }
  public ParseSpeed(speed: number): number { return this.SpeedValue(speed, true); }
  private SpeedValue(speed: number, toMetric: boolean = false): number {
    if (this.IsMetric())
      return Math.round(speed);
    else
      return Math.round(speed / (toMetric ? 0.621371 : 1.6093));
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  public GetMetersValue(length: number): number { return this.LengthValue(length); }
  public GetMeters(length: number): string { return this.GetMetersValue(length) + " " + this.Units("m"); }
  public ParseMeters(length: number): number { return this.LengthValue(length, true); }

  public GetKMetersValue(length: number): number { return this.LengthValue(length, false, true); }
  public GetKMeters(length: number): string { return this.GetKMetersValue(length) + " " + this.Units("km"); }
  public ParseKMeters(length: number): number { return this.LengthValue(length, true, true); }

  private LengthValue(length: number, toMetric: boolean = false, km: boolean = false): number {
    if (toMetric) {
      if (this.IsMetric())
        return km ? Math.round(length * 1000) : Math.round(length);
      return km ? Math.round(length * 1609.343) : Math.round(length / 3.28084);
    }
    else {
      if (this.IsMetric())
        return km ? Math.round(length * 0.001) : Math.round(length);
      return km ? Math.round(length * 0.000189394 * 3.28084) : Math.round(length * 3.28084);
    }
  }
}
